<template>
    <vx-modal padding="standard" :visible="!!model" @update:visible="model = null" size="md">
        <template v-slot:header> View Errors </template>
        <template v-slot:subheader>Import {{ model.import_id }}</template>

        <page-loading v-if="loading && !list.length"></page-loading>

        <div v-else>
            <vx-alert
                v-for="(error, index) in list"
                :key="list[index].error_id"
                color="danger"
                class="mb-2"
                :closeable="false"
            >
                <template v-slot:icon>
                    <font-awesome-icon widthAuto :icon="faTriangleExclamation" />
                </template>
                <strong v-if="typeof list[index].row_number === 'number'">Row {{ list[index].row_number }}</strong>
                {{ list[index].detail }}
            </vx-alert>

            <div v-if="fetchParams.cursor" class="mt-4">
                <vx-button
                    @click="loadData()"
                    color="muted-dark"
                    size="lg"
                    class="grow-0"
                    data-test="load-more-btn"
                    :loading="loading"
                >
                    Load More
                    <font-awesome-icon widthAuto :icon="faSpinner"></font-awesome-icon>
                </vx-button>
            </div>
        </div>

        <template v-slot:footer>
            <div class="flex flex-col-reverse gap-4 lg:flex-row">
                <vx-button @click.prevent="model = null" type="button" class="grow" size="lg" color="muted">
                    Close
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>

<script setup>
import { VxAlert, VxButton, VxModal } from '@voxie/frontend-components';
import { onMounted, watch } from 'vue';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { importsClient, groupImportsClient } from '~/services';
import { faSpinner, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PageLoading from '~/components/general/PageLoading.vue';

const model = defineModel({
    type: Object,
    required: false,
});

const { list, loading, fetchParams, fetchRecords } = useCursorPagination();
const defaultFilters = () => ({
    cursor: null,
    limit: 15,
});

watch(
    () => model.value,
    (data) => {
        if (data) {
            loadData();
        } else {
            list.value = [];
            fetchParams.value.cursor = null;
        }
    }
);

onMounted(() => {
    fetchParams.value = defaultFilters();
});

const loadData = () => {
    const request = model.value.group_id
        ? groupImportsClient.listErrors(
              model.value.team_id,
              model.value.group_id,
              model.value.import_type,
              model.value.import_id,
              { ...fetchParams.value }
          )
        : importsClient.listErrors(model.value.team_id, model.value.import_type, model.value.import_id, {
              ...fetchParams.value,
          });

    fetchRecords(request);
};
</script>
